import { RootState } from "@redux/store";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthRoute from "./AuthRoute";
import ProtectedRoute from "./ProtectedRoute";
import { useMemo } from "react";
import DashboardRoute from "./routes/dashboard";
import LoginRoute from "./routes/login";
import MainLayout from "@components/layout";
import DataAdminRoute from "@routes/dataAdmin";
import PengaturanAkunRoute from "@routes/pengaturanAkun";
import JadwalLoadingInRoute from "@routes/jadwalLoadingIn";
import LoadingInDetails from "@routes/loadingInDetails";
import JadwalLoadingOutRoute from "@routes/jadwalLoadingOut";
import LoadingOutDetails from "@routes/loadingOutDetails";
import JadwalLoadingRoute from "@routes/jadwalLoadingRoute";
import CreateLoadingIn from "@routes/createLoadingIn";
import DataBarangRoute from "@routes/dataBarang";
import DataBarangListRoute from "@routes/dataBarangList";

function App() {
  const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);

  const homeRoute = useMemo(() => {
    let pathRoute = '/dashboard';
    if (isAuthenticated) {
      const { role } = user;
      if (
        role !== 'owner'
      ) {
        pathRoute = '/jadwal-loading';
      }
    }
    return pathRoute;
  }, [isAuthenticated, user]);

  return (
    <MainLayout>
      <Routes>
        <Route
          path='/login'
          element={
            <AuthRoute>
              <LoginRoute />
            </AuthRoute>
          }
        />
        <Route
          path='/dashboard'
          element={
            <ProtectedRoute>
              <DashboardRoute />
            </ProtectedRoute>
          }
        />
        <Route
          path='/data-barang'
          element={
            <ProtectedRoute>
              <DataBarangRoute />
            </ProtectedRoute>
          }
        />
        <Route
          path='/data-barang/:id'
          element={
            <ProtectedRoute>
              <DataBarangListRoute />
            </ProtectedRoute>
          }
        />
        <Route
          path='/jadwal-loading'
          element={
            <ProtectedRoute>
              <JadwalLoadingRoute />
            </ProtectedRoute>
          }
        />
        <Route
          path='/jadwal-loading/in'
          element={
            <ProtectedRoute>
              <JadwalLoadingInRoute />
            </ProtectedRoute>
          }
        />
        <Route
          path='/jadwal-loading/in/create'
          element={
            <ProtectedRoute>
              <CreateLoadingIn />
            </ProtectedRoute>
          }
        />
        <Route
          path='/jadwal-loading/out'
          element={
            <ProtectedRoute>
              <JadwalLoadingOutRoute />
            </ProtectedRoute>
          }
        />
        <Route
          path='/jadwal-loading/in/:id'
          element={
            <ProtectedRoute>
              <LoadingInDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path='/jadwal-loading/out/:id'
          element={
            <ProtectedRoute>
              <LoadingOutDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path='/data-admin'
          element={
            <ProtectedRoute>
              <DataAdminRoute />
            </ProtectedRoute>
          }
        />
        <Route
          path='/pengaturan-akun'
          element={
            <ProtectedRoute>
              <PengaturanAkunRoute />
            </ProtectedRoute>
          }
        />
        <Route
          path='/'
          element={
            <Navigate
              to={homeRoute}
              replace
            />
          }
        />
      </Routes>
    </MainLayout>
  );
}

export default App;
